export const expandCollapseMixin = {
    data() {
        return {
            computedHeight: {},
        };
    },
    methods: {
        initHeight(ref, adh) {
            const height = getComputedStyle(this.$refs[ref]).height;
            if(adh) {
                let numHeight = height.slice(0, height.indexOf('px'));
                this.computedHeight[ref] = +numHeight + adh + 'px';
            } else {
                this.computedHeight[ref] = height;
            }
            
        }
    }
};